<template>
  <artmisads-modal  v-model:open="visible" :width="720" :maskClosable="false" :closable="false" :closeIcon="false"
    :footer="null" :header="false" :bodyStyle="{ padding: '0' }" class="link-bonus-modal">
    <div class="modal-content-container">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">
          <p>{{ $t('seller.dashboard.ccModalTitle') }}</p>
        </div>
        <svg-icon class="icon-app" name="close-cu" @click="handleClose"/>
      </div>
      <div class="modal-body">
        <p class="title">{{ $t('seller.dashboard.ccModalDear') }}</p>
        <p class="description description-bold">
          {{ $t('seller.dashboard.ccModalP1') }}
        </p>
        <p class="description">
          {{ $t('seller.dashboard.ccModalP2') }}
        </p>
      </div>
      <div class="footer-btns">
        <artmisads-button :loading="loading" type="primary" class="get-start-btn" @click="handleGetStart">{{ $t('seller.dashboard.ccModalCreateBtn') }}</artmisads-button>
      </div>
    </div> 
      <div class="modal-footer">
        <a-checkbox v-model:checked="checked">{{ $t('seller.dashboard.ccModalDontShowAgain') }}</a-checkbox>
      </div>
      <!-- <div class="learn-more">
        <a href="javascript:;" @click="handleLearnMore">Learn more about our bonus program</a>
      </div> -->
    </div>
  </artmisads-modal>
</template>

<script setup>


import { ref } from 'vue'
import SvgIcon from '~/components/SvgIcon.vue'
import {  useRouter } from "vue-router"
import { adminApi } from "~/server/index"
const router = useRouter()
const checked = ref(true)

const visible = ref(false)
const emit = defineEmits(['close'])
const loading = ref(false)
const handleClose = async () => {
  visible.value=false
}

const handleGetStart = async () => {
  loading.value = true
  if(checked.value){
    adminApi.dismissPopActive({
      key: 'acc_bonus_program_released'
    }).then(res => {
      if(res.success){
        router.push('/seller/creatorConnections/accBonusProgram')
      }
    })
  }else{
    router.push('/seller/creatorConnections/accBonusProgram')
  }
  loading.value = false
  emit('close')
}

const showModal = () => {
  visible.value = true
}

defineExpose({
  showModal
})
</script>

<style scoped lang="less">

.link-bonus-modal {
  :deep(.artmisads-modal-content) {
    border-radius: 8px;
    overflow: hidden;
    padding: 24px;
    background-image: url('../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .modal-content-container{
    // background-color: #FBFBFE;
  }
  .modal-footer {
    text-align: center;
   margin-top: -20px;
   padding-bottom: 18px;
  }
  .modal-content {
    min-height: 420px;
    text-align: left;
    background-image: url('../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .modal-header {
      position: relative;
      .icon-app{
        position: absolute;
        right: 24px;
        top: 24px;
        font-size: 24px;
        cursor: pointer;
      }
      .modal-header-title {
        color: #0f0629;
        font-family: "Sora", sans-serif;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        padding: 24px 72px 20px 40px;
        letter-spacing: 0.69px;
      }
    }

    .modal-body {
      border-radius: var(--Radius-Radius-10, 10px);
      padding: 20px 30px;
      margin: 0 40px;
      border: 1px solid #FFF;
      background: #FFF;
      box-shadow: 0 1px 4px 0 #0000000a, 0 2px 16px 0 #00000014;
      height: 230px;

      .title {
        color: #0f0629;
        font-family: "Sora", "PingFang SC", sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        margin-bottom: 12px;
      }

      .description {
        color: #0f0629;
        font-family: "PingFang SC", "Sora", sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 16px;

        &.description-bold {
          font-weight: 600;
          margin-bottom: 12px;
        }

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    .footer-btns {
      text-align: center;
      margin-top: 23px;

      .artmisads-btn {
        min-width: 120px;
      }
    }

    .learn-more {
      text-align: center;

      a {
        font-size: 14px;
        color: var(--primary-color);
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>